export enum ESearchType {
    Address = 'Address',
    MlsNumber = 'MlsNumber',
    Other = 'Other'
}
